export const RENT_GUARANTEE_LISTING_STATE = {
  NOT_ENROLLED: 'notEnrolled',
  PENDING: 'pending',
  WILL_ACTIVATE: 'willActivate',
  ACTIVE: 'active',
  ACTIVE_RENEW: 'activeRenew',
  EXPIRED: 'expired',
  PENDING_CANCELLATION: 'pendingCancellation',
  CANCELLED: 'cancelled',
  COVERAGE_REQUEST_SIGNED: 'coverageRequestSigned',
  COVERAGE_REQUEST_SIGNING_CANCELLED: 'coverageRequestSigningCancelled',
  PENDING_ACTIVATION: 'pendingActivation',
  MISSING_PAYMENT_METHOD: 'missingPaymentMethod',
  DROPPED: 'dropped',
  HIDE: 'hide',
  REVIEWING_ZRM_TOOLS_AND_SECURITY_DEPOSIT: 'reviewingZrmToolsAndSecurityDeposit',
  LIGHTWEIGHT_OPT_IN: 'lightweightOptIn',
  SUNSET: 'sunset',
};

export enum RENTAL_PROTECTION_PAYMENT_OPTIONS {
  RENTER_PAYS = 'RENTER_PAYS',
  LANDLORD_PAYS = 'LANDLORD_PAYS',
  SPLIT_PAYMENT = 'SPLIT_PAYMENT',
}

export const RENTAL_PROTECTION_PAYMENT_OPTIONS_REQUEST_VALUE = {
  [RENTAL_PROTECTION_PAYMENT_OPTIONS.RENTER_PAYS]: 'tenantPays',
  [RENTAL_PROTECTION_PAYMENT_OPTIONS.LANDLORD_PAYS]: 'landlordPays',
  [RENTAL_PROTECTION_PAYMENT_OPTIONS.SPLIT_PAYMENT]: 'splitPay',
};

export const RENTAL_PROTECTION_PAYMENT_OPTIONS_RESPONSE_MAP = {
  [RENTAL_PROTECTION_PAYMENT_OPTIONS_REQUEST_VALUE.RENTER_PAYS]: RENTAL_PROTECTION_PAYMENT_OPTIONS.RENTER_PAYS,
  [RENTAL_PROTECTION_PAYMENT_OPTIONS_REQUEST_VALUE.LANDLORD_PAYS]: RENTAL_PROTECTION_PAYMENT_OPTIONS.LANDLORD_PAYS,
  [RENTAL_PROTECTION_PAYMENT_OPTIONS_REQUEST_VALUE.SPLIT_PAYMENT]: RENTAL_PROTECTION_PAYMENT_OPTIONS.SPLIT_PAYMENT,
};
